import { useInfiniteQuery } from '@tanstack/react-query';

import { type BaseMaintenanceHistoryRequest, MaintenanceRequester, type PastMaintenancesMaps } from '@cobliteam/api-lib/src/dashboard/maintenance';

import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();
const maintenanceRequester = new MaintenanceRequester({
  host: env.apiHost,
});

const QUERY_KEY = 'MAINTENANCE';

const getNextPageParam = (lastPage: PastMaintenancesMaps, allPages: PastMaintenancesMaps[]) => {
  return undefined;
};

const useGetMaintenanceHistory = (request: BaseMaintenanceHistoryRequest) => {
  return useInfiniteQuery<PastMaintenancesMaps>({
    initialPageParam: 0,
    queryKey: [QUERY_KEY, 'ROWS', JSON.stringify(request)],
    queryFn: () => maintenanceRequester.loadPastMaintenances(),
    staleTime: 1000 * 60 * 30, // 30 minutes
    getNextPageParam,
  });
};

export { useGetMaintenanceHistory };
